ConnectStore = require 'components/enhancers/connect_store'
QuestionsStatusesStore = require 'stores/questions_statuses_store'
{ kebabCase } = require 'lodash'
{ MDA_HANDOUT } = require 'lib/db_docs/doc_types'
{ HANDOUT_STATUSES } = require 'lib/mda_handouts_helper'
{ DOCUMENT_STATUSES } = require 'lib/document_sections_v2_helper'
{ useCoffeeCallback, useI18n, useCoffeeMemo } = require 'lib/react_utils'
ProgressSelect = require 'components/evidence_syntheses/progress_select'

storeConnector =
  QuestionsStatusesStore: (Store, props) ->
    questionStatuses: Store.getQuestionStatuses props.documentId

DocumentProgressSelect = ({
  afterStatusChange,
  documentId,
  documentType,
  editable,
  questionStatuses,
  showLabel,
  statusOverride
  withCompleted,
}) ->

  groupKey = if documentType is MDA_HANDOUT then 'handoutStatus' else 'documentStatus'

  statusesList = useCoffeeMemo [documentType], ->
    Immutable.fromJS if documentType is MDA_HANDOUT
      HANDOUT_STATUSES
    else
      DOCUMENT_STATUSES

  statusModifierPrefix = if documentType is MDA_HANDOUT then 'mda-' else ''

  renderTrigger = useCoffeeCallback [statusOverride, statusModifierPrefix], ({ status, toggleForm }) ->
    <div>
      <ShortRect
        status={statusOverride or status}
        statusModifierPrefix={statusModifierPrefix}
        onClick={toggleForm}
      />
    </div>

  emptyComponent = useCoffeeMemo [statusOverride, statusModifierPrefix], ->
    <ShortRect
      status={statusOverride or 'inactive'}
      statusModifierPrefix={statusModifierPrefix}
      onClick={null}
    />

  <ProgressSelect
    afterStatusChange={afterStatusChange}
    editable={editable && !_.isEmpty(documentId)}
    emptyComponent={emptyComponent}
    groupKey={groupKey}
    questionId={documentId}
    questionStatuses={questionStatuses}
    renderTrigger={renderTrigger}
    showLabel={showLabel}
    statusesList={statusesList}
    statusModifierPrefix={statusModifierPrefix}
    statusOverride={statusOverride}
    withCompleted={withCompleted}
  />

ShortRect = ({ status, statusModifierPrefix, onClick }) ->
  classes = classNames "question-progress__rects__rect",
    "question-progress__rects__rect--#{statusModifierPrefix}#{kebabCase(status)}"
  <div className='question-progress'>
    <div className="question-progress__rects">
      <span className={classes} onClick={onClick}>PH</span>
    </div>
  </div>

module.exports = ConnectStore DocumentProgressSelect, [QuestionsStatusesStore], storeConnector
